export enum GroupOrderStatus {
  STARTED = 'STARTED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  PLACING = 'PLACING',
  DONE = 'DONE',
}
